import React, { useState } from 'react';
import {
  PlayIcon,
} from '@revfluence/fresh-icons/solid/esm';
import { Skeleton } from '@frontend/shadcn/components/ui/skeleton';
import Empty from '@frontend/app/refresh-components/Empty';
import { PostPreviewUrls } from './types';

export interface MediaItemProps {
  post: PostPreviewUrls;
}

export const MediaItem: React.FC<MediaItemProps> = ({ post }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const handleLoad = () => {
    setIsLoading(false);
  };

  const handleError = () => {
    setIsLoading(false);
    setHasError(true);
  };

  if (post.media_type === 'image') {
    return (
      <div className="relative w-full h-[462px]">
        {isLoading && (
          <div className="absolute inset-0 flex justify-center items-center">
            <Skeleton className="w-full h-full" />
          </div>
        )}
        {hasError ? (
          <div className="w-full h-[462px] flex justify-center items-center">
            <Empty
              icon={PlayIcon}
              title="Image Unavailable"
              description="This image cannot be loaded or displayed"
              size="md"
            />
          </div>
        ) : (
          <img
            src={post.url}
            alt="Prospect"
            className="w-full h-[462px] object-cover"
            onLoad={handleLoad}
            onError={handleError}
            style={{ display: isLoading ? 'none' : 'block' }}
          />
        )}
      </div>
    );
  }

  return (
    <div className="relative w-full h-[462px]">
      {isLoading && (
        <div className="absolute inset-0 flex justify-center items-center">
          <Skeleton className="w-full h-full" />
        </div>
      )}
      {hasError ? (
        <div className="w-full h-[462px] flex justify-center items-center">
          <Empty
            icon={PlayIcon}
            title="Video Unavailable"
            description="This video cannot be loaded or played"
            size="md"
          />
        </div>
      ) : (
        <video
          src={post.url}
          autoPlay
          muted
          loop
          className="w-full h-[462px] object-cover"
          onLoadedData={handleLoad}
          onError={handleError}
          style={{ display: isLoading ? 'none' : 'block' }}
        />
      )}
    </div>
  );
};
